export default __webpack_public_path__ + "static/media/keyvis_players_dt@2x.23a6623e.png";